/**
 * P1 운영 관제 센터 — 24h 활동 요약 + 최근 이벤트 타임라인.
 */
import { OperationsOverview } from '../../services/operationsApi';

interface Props {
  data: OperationsOverview;
}

export default function OperationsActivity({ data }: Props) {
  const { decisions, execution_logs, server_logs } = data;

  return (
    <section className="op-activity-grid">
      <div className="op-activity-card">
        <h3>최근 24h 활동</h3>
        <ul className="op-activity-stats">
          <li>
            <span>ExecutionLog</span>
            <strong>{execution_logs.total}건</strong>
          </li>
          <li>
            <span>DecisionRecord</span>
            <strong>{decisions.total}건</strong>
          </li>
          <li>
            <span>실행 완료 (Decision)</span>
            <strong>{decisions.executed_count}건</strong>
          </li>
          <li>
            <span>거부 (Decision)</span>
            <strong>{decisions.rejected_count}건</strong>
          </li>
        </ul>
        <div className="op-action-dist">
          <span className="op-section-label">Action 분포 (DecisionRecord)</span>
          <ul>
            {Object.entries(decisions.by_action).map(([action, count]) => (
              <li key={action}>
                <span>{action}</span>
                <strong>{count}</strong>
              </li>
            ))}
            {Object.keys(decisions.by_action).length === 0 && (
              <li className="op-empty">데이터 없음 (시장 휴장 또는 신규 표본 부족)</li>
            )}
          </ul>
        </div>
      </div>

      <div className="op-activity-card">
        <h3>최근 거부 사유</h3>
        {server_logs.recent_rejections.length === 0 ? (
          <p className="op-empty">24h 내 거부 없음</p>
        ) : (
          <ul className="op-event-list">
            {server_logs.recent_rejections.map((r) => (
              <li key={r.id}>
                <span className="op-event-meta">
                  {r.symbol} · {r.action}
                </span>
                <span className="op-event-reason">{r.reject_reason || '-'}</span>
              </li>
            ))}
          </ul>
        )}
      </div>

      <div className="op-activity-card">
        <h3>최근 이슈 로그</h3>
        {server_logs.recent_issue_logs.length === 0 ? (
          <p className="op-empty">24h 내 이슈 없음</p>
        ) : (
          <ul className="op-event-list">
            {server_logs.recent_issue_logs.map((log) => (
              <li key={log.id}>
                <span className="op-event-meta">
                  {log.symbol} · {log.action}
                </span>
                <span className="op-event-reason">{log.reason}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
